// extracted by mini-css-extract-plugin
module.exports = {"footerText":"Footer_footerText__3Q_Rv","footer":"Footer_footer__3Xwkp"};